// 報廢品列表
<template>
  <div class="box">
    <breadcrumb :breadcrumb="breadcrumb"></breadcrumb>
    <div class="card_wrap">
      <h5>{{ language("scrapProducts.title") }}</h5>
      <div class="card">
        <div class="status">
          <status-card
            :dataArr="productStatus"
            labelWidth="0px"
            :title="language('scrapProducts.queryStatus')"
            @change="formChange1"
          ></status-card>
        </div>

        <div class="status">
          <status-card
            :dataArr="onlineStatus"
            labelWidth="0px"
            :title="language('productDetails.onlineStatus')"
            @change="formChange2"
          ></status-card>
        </div>
        <!-- 
        <div class="status">
          <status-card
            :dataArr="productType"
            labelWidth="0px"
            :title="language('productDetails.productType')"
            @change="formChange3"
          ></status-card>
        </div> -->

        <div class="input">
          <input-card
            :title="language('scrapProducts.transaction')"
            :dataArr="inputArr"
            labelPosition="top"
            @change="formChange4"
          ></input-card>
        </div>
      </div>
      <div class="button_wrap">
        <el-button type="primary" @click="search">{{
          language("productDetails.search")
        }}</el-button>
      </div>
    </div>

    <div class="table_wrap" v-loading="loading">
      <div class="count">
        <div>
          {{ language("productDetails.results") }}: {{ results }}
          {{ language("productDetails.rows") }}
        </div>
        <div>
          <page :total="results" @pageChange="pageChange" ref="page"></page>
        </div>
      </div>
      <div class="button_wrap">
        <div class="button_wrap download">
          <div class="title">{{ language("productDetails.action") }}</div>
          <template v-if="$menuList['SIS-Product-Discount-Info-Add']">
            <el-button type="primary" @click="openAdd">{{
              language("scrapProducts.add")
            }}</el-button>
            <el-button type="primary" @click="batchAddDialog = true">{{
              language("scrapProducts.batchAdd")
            }}</el-button>
          </template>
          <!-- <el-button type="primary" @click="download">{{
            language("productDetails.download")
          }}</el-button>
          <el-button type="primary" @click="openBatch">{{
            language("productDetails.batch")
          }}</el-button> -->
          <!-- <el-button type="primary" @click="downloadLog">{{
            language("productDetails.downloadLog")
          }}</el-button> -->
        </div>
        <template v-if="$menuList['SIS-Product-Discount-Info-Edit']">
          <div class="button_wrap download">
            <div class="title">
              {{ language("productDetails.otherHandling") }}
            </div>
            <el-button type="primary" @click="changeStatus(1)">{{
              language("productDetails.online")
            }}</el-button>
            <el-button type="primary" @click="changeStatus(0)">{{
              language("productDetails.offline")
            }}</el-button>
            <el-button type="primary" @click="changeStatus(2)">{{
              language("productDetails.invisbile")
            }}</el-button>
          </div>
        </template>
      </div>
      <div class="table">
        <cc-table
          :loadData="false"
          :dataArr="dataArr"
          :config="table"
          :params="params"
          :refeshParams="refeshTable"
          :emptyText="language('productDetails.emptyText')"
          @selecting-result="selectingResult"
          :showIndex="false"
          :buttonsWidth="100"
        ></cc-table>
      </div>
    </div>

    <!--商品編輯--->
    <template v-if="dialog">
      <el-dialog
        :close-on-click-modal="false"
        :title="language('productDetails.edit')"
        :visible.sync="dialog"
        width="90%"
        append-to-body
      >
        <edit-product :editData="editData" @success="success"></edit-product>
      </el-dialog>
    </template>
    <el-dialog
      :close-on-click-modal="false"
      :title="language('productDetails.downloadLog')"
      :visible.sync="downloadLogDialog"
      width="90%"
      append-to-body
    >
      <template v-if="downloadLogDialog">
        <cc-table
          :loadData="true"
          :config="tableLog"
          :params="paramslog"
          :refeshParams="refeshTable"
          :buttonsWidth="110"
        ></cc-table>
      </template>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :title="language('productDetails.batch')"
      :visible.sync="showBatch"
      width="90%"
      append-to-body
    >
      <template v-if="showBatch">
        <batch></batch>
      </template>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :title="language('scrapProducts.addDialog')"
      :visible.sync="addDialog"
      width="50%"
      append-to-body
    >
      <template v-if="addDialog">
        <add-scrap-products @success="success"></add-scrap-products>
      </template>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :title="language('scrapProducts.batchAddDialog')"
      :visible.sync="batchAddDialog"
      width="70%"
      append-to-body
    >
      <template v-if="batchAddDialog">
        <batch-add-scrap-products
          @success="batchAddSuccess"
        ></batch-add-scrap-products>
      </template>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :title="language('scrapProducts.batchAddErrDialog')"
      :visible.sync="batchAddErrDialog"
      width="80%"
      append-to-body
    >
      <template v-if="batchAddErrDialog">
        <cc-table
          :loadData="false"
          :dataArr="batchAddErr"
          :config="tableError"
          :params="{}"
          :refeshParams="-1"
        ></cc-table>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumb from "../../components/breadcrumb";
import statusCard from "../../components/statusCard";
import inputCard from "../../components/inputCard";
import page from "../../components/page";
import editProduct from "./components/editProduct";
import batch from "./components/batch";
import AddScrapProducts from "./components/addScrapProducts";
import BatchAddScrapProducts from "./components/batchAddScrapProducts";
export default {
  components: {
    breadcrumb,
    statusCard,
    inputCard,
    page,
    editProduct,
    batch,
    AddScrapProducts,
    BatchAddScrapProducts,
  },
  data() {
    return {
      loading: false,
      breadcrumb: {
        title: this.language("scrapProducts.title"),
        list: [
          {
            name: this.language("productDetails.breadcrumbList_1"),
          },
          {
            name: this.language("scrapProducts.title"),
          },
        ],
      },
      productStatus: [
        {
          title: " ",
          checkbox: [],
          list: [
            {
              name: this.language("productDetails.submit"),
              apiName: "status",
              value: "0",
            },
            {
              name: this.language("productDetails.approved"),
              apiName: "status",
              value: "1",
            },
            {
              name: this.language("productDetails.rejected"),
              apiName: "status",
              value: "2",
            },
            // {
            //   name: this.language("productDetails.hide"),
            //   apiName: "Hide",
            //   value: "Hide",
            // },
          ],
        },
      ],

      onlineStatus: [
        {
          title: " ",
          checkbox: [],
          list: [
            {
              name: this.language("productDetails.online"),
              apiName: "saleStatus",
              value: "1",
            },
            {
              name: this.language("productDetails.offline"),
              apiName: "saleStatus",
              value: "0",
            },
            {
              name: this.language("productDetails.invisible"),
              apiName: "saleStatus",
              value: "2",
            },
          ],
        },
      ],

      //   productType: [
      //     {
      //       title: "",
      //       checkbox: [],
      //       list: [
      //         {
      //           name: this.language("productDetails.book"),
      //           apiName: "type",
      //           value: "BOOK",
      //         },
      //         {
      //           name: this.language("productDetails.stat"),
      //           apiName: "type",
      //           value: "STAT",
      //         },
      //       ],
      //     },
      //   ],

      inputArr: [
        {
          name: "SKU ID / Barcode",
          apiName: "barcode",
          value: "",
        },
        {
          name: "Model ID",
          apiName: "mchProductId",
          value: "",
        },
        {
          name: "Product Name",
          apiName: "name",
          value: "",
        },
        {
          name: "Article Master",
          apiName: "productNum",
          value: "",
        },
        {
          name: "Original Article Master",
          apiName: "originalProductNum",
          value: "",
        },
      ],

      results: 0,
      dataArr: [],
      params: {},
      refeshTable: -1,
      table: {
        api: "admin/merchant/product/query",
        showPager: false,
        selection: true,
        selectionNoSubmit: true,
        selectingResult: true,
        indexFixed: "left",
        columns: [
          {
            prop: "saleStatus",
            lable: "Displayed",
            type: "tag",
            minWidth: 110,
            options: {
              1: {
                tagType: "success",
                text: this.language("productDetails.online"),
              },
              0: {
                tagType: "info",
                text: this.language("productDetails.offline"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.invisible"),
              },
              // 1: {
              //   tagType: "danger",
              //   text: "不支持线上销售",
              // },
              // 2: {
              //   tagType: "danger",
              //   text: "待上架",
              // },
            },
          },
          {
            prop: "status",
            lable: "Status",
            type: "tag",
            minWidth: 120,
            options: {
              0: {
                tagType: "info",
                text: this.language("productDetails.submit"),
              },
              1: {
                tagType: "success",
                text: this.language("productDetails.approved"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.rejected"),
              },
              // hide: {
              //   tagType: "danger",
              //   text: this.language("productDetails.hide"),
              // },
            },
          },
          {
            prop: "type",
            lable: "Type",
            type: "tag",
            minWidth: 215,
            options: {
              H: {
                tagType: "success",
                text: "Non Book",
              },
              C: {
                tagType: "success",
                text: "(Book) Mainland/國版",
              },
              D: {
                tagType: "success",
                text: "(Book) HKG/港版",
              },
              E: {
                tagType: "success",
                text: "(Book) TWN/台版",
              },
              F: {
                tagType: "success",
                text: "(Book) Others/外文版",
              },
              A: {
                tagType: "success",
                text: "(Book)SUP/本版",
              },
              'DT000': {
                tagType: "success",
                text: "PRY.HK/小學教參",
              },
              "DT100": {
                tagType: "success",
                text: "SEC.HK/中學教參",
              },
              "DT200": {
                tagType: "success",
                text: "UNI.HK/大專教參",
              },
              'FT000': {
                tagType: "success",
                text: "PRY.F/外文小學教參",
              },
              "FT100": {
                tagType: "success",
                text: "SEC.F/外文中學教參",
              },
              'FT200': {
                tagType: "success",
                text: "UNI.F/外文大專教參",
              },
            },
          },
          // {
          //   prop: "isDiscount",
          //   lable: this.language("scrapProducts.scrapProducts"),
          //   minWidth: 100,
          //   type: "tag",
          //   options: {
          //     1: {
          //       tagType: "success",
          //       text: "是",
          //     },
          //     0: {
          //       tagType: "info",
          //       text: "否",
          //     },
          //   },
          // },
          {
            prop: "mchProductId",
            lable: "Model ID",
            minWidth: 150,
          },

          {
            prop: "barcode",
            lable: "SKU ID（Barcode）",
            minWidth: 150,
          },
          {
            prop: "productNum",
            lable: "Article Master",
            minWidth: 150,
          },
          {
            prop: "originalProductNum",
            lable: "Original Article Master",
            minWidth: 150,
          },
          {
            prop: "name",
            lable: "Product Name（Chi.）",
            minWidth: 180,
          },
          {
            prop: "cover",
            lable: "Product Cover",
            minWidth: 80,
            type: "img",
            urlPropName: "cover",
            sourceUrlPropName: "cover",
            // imgCompressParams: "?x-oss-process=image/resize,w_600",
            w: 40,
            h: 40,
          },
          {
            prop: "categories",
            lable: "Category（System）",
            minWidth: 120,
          },
          {
            prop: "brand",
            minWidth: 120,
            lable: "Brand",
          },
          {
            prop: "salePrice",
            lable: "Selling Price(HKD)",
            render: (rows) => {
              return this.$utils.toFixedDigit(rows.salePrice * 1, 2);
            },
            minWidth: 100,
          },
          {
            prop: "updateAdminName",
            lable: "Update By",
            minWidth: 100,
          },
          {
            prop: "updateTime",
            lable: "Last Update",
            minWidth: 200,
          },
          {
            prop: "createTime",
            lable: "Create Date",
            minWidth: 200,
          },
        ],
        buttons: [
          //   {
          //     name: this.language("productDetails.edit"),
          //     click: (row, index) => {
          //       this.edit(row, index);
          //     },
          //   },
        ],
      },
      form: {
        pageSize: 10,
        pageNo: 1,
      },
      form1: {},
      form2: {},
      form3: {},
      form4: {},
      dialog: false,
      editData: {},
      ids: [],
      downloadLogDialog: false,
      tableLog: {
        api: "admin/merchant/product/export/query",
        showPager: true,
        columns: [
          {
            prop: "createTime",
            lable: "CreateTime",
            minWidth: 150,
          },

          {
            prop: "title",
            lable: "Title",
            minWidth: 100,
          },
          {
            prop: "address",
            lable: "Address",
            minWidth: 500,
          },
          {
            prop: "adminName",
            lable: "AdminName",
            minWidth: 150,
          },
          {
            prop: "status",
            lable: "Status",
            minWidth: 100,
            type: "tag",
            options: {
              1: {
                tagType: "success",
                text: "Success",
              },
              2: {
                tagType: "danger",
                text: "Danger",
              },
              0: {
                tagType: "info",
                text: "Info",
              },
            },
          },
        ],
        buttons: [
          {
            name: "download",
            click: (row) => {
              window.open(row.address, "下載");
            },
            check: (row) => {
              if (row.status == 1) {
                return true;
              } else {
                return false;
              }
            },
          },
        ],
      },
      paramslog: {},
      showBatch: false,
      addDialog: false,
      batchAddDialog: false,
      batchAddErrDialog: false,
      batchAddErr: [],
      tableError: {
        api: "",
        showPager: false,
        columns: [
          {
            prop: "errorMsg",
            lable: "Error",
            minWidth: 150,
          },
          {
            prop: "productNum",
            lable: "Article Master",
            minWidth: 150,
          },
          {
            prop: "salePrice",
            lable: "Selling Price (HKD)",
            minWidth: 100,
        
          },
        ],
        buttons: [],
      },
    };
  },
  methods: {
    pageChange(e) {
      this.form.pageSize = e.pageSize;
      this.form.pageNo = e.pageNo;
      this.getData(this.form);
    },
    getData(e) {
      this.loading = true;
      e.shopNum = this.shopData.shopNum;
      e.mchShopNum = this.shopData.shopNum;
      this.ccRequest
        .do("admin/merchant/product/query?isDiscount=1", e)
        .then((res) => {
          this.loading = false;
          this.dataArr = res.rows;
          this.results = res.total;
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.response.data.message);
        });
    },
    formChange1(e) {
      this.form1 = { ...e };
      this.svaeForm(e, this.form2, this.form3, this.form4);
    },
    formChange2(e) {
      this.form2 = { ...e };
      this.svaeForm(this.form1, e, this.form3, this.form4);
    },
    formChange3(e) {
      this.form3 = { ...e };
      this.svaeForm(this.form1, this.form2, e, this.form4);
    },
    formChange4(e) {
      this.form4 = { ...e };
      this.svaeForm(this.form1, this.form2, this.form4, e);
    },
    svaeForm(form1, form2, form3, form4) {
      this.form = {
        ...form1,
        ...form2,
        ...form3,
        ...form4,
        // pageSize: 10,
        // pageNo: 1,
      };
    },
    search() {
      this.form.pageSize = 10;
      this.form.pageNo = 1;
      this.$refs.page.init();
      this.getData(this.form);
    },
    edit(e, index) {
      this.dialog = true;
      this.editData = { ...e };
      if (this.editData.listPrice) {
        this.editData.listPrice = this.editData.listPrice / 100;
      }
      if (this.editData.recommendPrice) {
        this.editData.recommendPrice = this.editData.recommendPrice / 100;
      }
      if (this.editData.salePrice) {
        this.editData.salePrice = this.editData.salePrice / 100;
      }
      if (this.editData.productCost) {
        this.editData.productCost = this.editData.productCost / 100;
      }
    },

    selectingResult(e) {
      let ids = [];
      for (let i = 0; i < e.length; i++) {
        ids.push(e[i].id);
      }
      this.ids = ids;
    },
    changeStatus(status) {
      if (this.ids.length == 0) {
        this.$message.error(this.language("productDetails.chooseProductTips"));
        return false;
      }
      this.$confirm(
        this.language("common.changeTips"),
        this.language("common.tips"),
        {
          confirmButtonText: this.language("common.confirm"),
          cancelButtonText: this.language("common.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.ccRequest
            .do(
              "admin/merchant/product/updateProductsSaleStatus",
              { ids: this.ids.join(","), saleStatus: status },
              "GET"
            )
            .then((res) => {
              this.getData(this.form);
              this.$message.success(this.language("productDetails.success"));
              this.ids = [];
            })
            .catch((err) => {
              console.log(err);
              this.$message.error(err.response.data.message);
            });
        })
        .catch(() => {});
    },
    download() {
      if (this.ids.length == 0) {
        this.$message.error(this.language("productDetails.chooseProductTips"));
        return false;
      }

      let url =
        `/admin/merchant/product/exportProducts2File?shopNum=${this.shopData.shopNum}&mchShopNum=${this.shopData.shopNum}&appId=supnr&ids=` +
        this.ids;
      window.open(url);
      this.$message(this.language("common.downloading"));

      // let data = {
      //   shopNum: this.shopData.shopNum,
      //   mchShopNum: this.shopData.shopNum,
      //   ids: this.ids,
      // };
      // this.ccRequest
      //   .do("admin/merchant/product/export/saveByProductCondition", data)
      //   .then((res) => {
      //     this.$message(this.language("common.downloading"));
      //   })
      //   .catch((err) => {
      //     this.$message.error(err.response.data.message);
      //   });
    },
    downloadLog() {
      this.downloadLogDialog = true;
    },
    success() {
      this.getData(this.form);
      this.dialog = false;
      this.addDialog = false;
    },
    openBatch() {
      this.showBatch = true;
    },
    openAdd() {
      this.addDialog = true;
    },
    delete(e) {
      this.$confirm(
        this.language("scrapProducts.removeTips"),
        this.language("common.tips"),
        {
          confirmButtonText: this.language("common.confirm"),
          cancelButtonText: this.language("common.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.ccRequest
            .do("admin/merchant/product/delete", { id: e.id })
            .then((res) => {
              this.$message({
                type: "success",
                message: this.language("shopBannerForm.success"),
              });
              this.getData(this.form);
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch(() => {});
    },
    batchAddSuccess(e) {
      this.batchAddDialog = false;
      if (e.data && e.data.data && e.data.data.length>1) {
        this.batchAddErrDialog = true;
        this.batchAddErr = e.data.data;
      }
      this.getData(this.form);
      console.log(e);
    },
  },
  mounted() {
    if (this.$menuList["SIS-Product-Discount-Info-Edit"]) {
      this.table.buttons.push({
        name: this.language("productDetails.edit"),
        click: (row, index) => {
          this.edit(row, index);
        },
      });
    }
    // if (this.$menuList["SIS-Product-Discount-Info-Delete"]) {
    //   this.table.buttons.push({
    //     name: this.language("scrapProducts.delete"),
    //     click: (row, index) => {
    //       this.delete(row, index);
    //     },
    //   });
    // }
    this.shopData = this.$shopData;
    this.getData({
      pageSize: 10,
      pageNo: 1,
    });
  },
};
</script>
<style scoped lang="scss">
.box {
  height: 100%;
}
.card_wrap {
  background: #f7f7f7;
  padding: 20px;
  h5 {
    font-size: $title;
    margin: 10px 0 20px 0;
  }
  .card {
    display: flex;
    flex-wrap: wrap;
    .status {
      flex: 1;
    }
    .status {
      padding-right: 20px;
      flex: 1;
    }
    .input {
      width: 300px;
      flex: 1;
    }
  }
}
.tips {
  margin-top: 10px;
  font-size: $sbuTitle;
}
.button_wrap {
  margin-top: 20px;
  display: flex;
  align-items: center;
  .title {
    margin-right: 10px;
    font-weight: 600;
  }
}
.download {
  margin-right: 20px;
}
.table_wrap {
  margin-top: 50px;
  .count {
    font-size: $sbuTitle;
    margin-bottom: 20px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .table {
    margin-top: 20px;
  }
}
</style>
